<template>  
    <v-app-bar elevation="0" color="primary" height="56" fixed dense app>
        <v-app-bar-nav-icon class="white--text" @click="handleDrawerToggle" />
        <!-- <v-toolbar-title class="align-center white--text"><span class="title third--text">{{ $route.meta.title }}</span></v-toolbar-title> -->
        <v-spacer></v-spacer> 
        <!-- <v-icon color="primary" class="ml-4 mr-1" size="40">fingerprint</v-icon>       
        <v-toolbar-title class="align-center"><span class="title third--text">Application</span></v-toolbar-title>    -->           
        <span class="white--text font-weight-medium body-1">Bienvenido, {{ toCapitalize(authenticated?.name) }}</span>
        <v-menu class="elelvation-1" origin="center center" transition="slide-y-transition" :nudge-bottom="10" offset-y>
            <template v-slot:activator="{ on }">
                <v-avatar size="40" color="white" class="ml-4 mr-1" v-on="on" style="cursor:pointer;">
                    <v-icon color="grey" size="40">mdi-account-circle</v-icon>
                </v-avatar>
            </template>
            <!--  -->
            <v-list>
                <v-list-item @click="DialogChangePassword = true;">
                    <v-list-item-icon class="mr-2">
                        <v-icon size="25" color="grey darken-1">mdi-lock-reset</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title class="font-weight-medium">Cambiar contraseña</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <!--  -->
                <v-list-item @click="preLogout()">
                    <v-list-item-icon class="mr-2">
                        <v-icon size="25" color="grey darken-1">mdi-exit-to-app</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title class="font-weight-medium">Cerrar sesión</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-menu>
        <!--  -->
        <DialogChangePassword v-if="DialogChangePassword" @close="DialogChangePassword=false"></DialogChangePassword>
    </v-app-bar>
</template>

<script>

import {mapGetters, mapActions} from 'vuex';
import DialogChangePassword from '@/components/user/ChangePassword.vue';

export default {
    name: 'AppToolbar',
    components: {
        DialogChangePassword
    },
    data(){
        return {
            DialogChangePassword: false,
        }
    },
    computed:{
        ...mapGetters({
            authenticated: 'auth/authenticated',
        })
    },
    methods:{
        ...mapActions({
            logout: 'auth/logout',
        }),
        handleDrawerToggle(){
            this.$emit('side-icon-click')
        },
        preLogout() {
            swal({ title: "¿Desea cerrar sesión?", icon: "warning", closeOnClickOutside: false, closeOnEsc: false,
                buttons: {
                    cancel:{ text: "Cancelar", value: false, visible: true, closeModal: true },
                    confirm:{ text: "Continuar", value: true, visible: true, className: "primary", closeModal: false }
                }
            })
            .then(enviar => {
                if (!enviar) throw null;
                var m = document.querySelector(".swal-button--cancel");
                m.setAttribute("disabled", "disabled");
                return this.logout();
            })
            .then( response => {        
                swal({title: "Sesión cerrada con éxito", icon: "success", button: "Cerrar"}).then(cerrar => {
                    window.location = '/';
                    //this.$router.replace({ name: 'Login'});
                })
            })
            .catch((error) => {
                if(error) {
                    this.handleError(error)
                }
                else {
                    swal.stopLoading();
                    swal.close();
                }
            });
        }
    }
}
</script>